export const FormErrorMessage = (props: { message: string }): JSX.Element => (
  <span className="form-text m-b-none text-left pl-3 text-danger">
    {props.message}
  </span>
);
